export const ADD_REMOVE_ICON_TYPE = {
  ADD: 'add',
  REMOVE: 'remove',
};
